export class InteractiveLoginRequiredAuthError extends Error {
  public name: string;

  constructor(message: string) {
    super(message);

    this.name = 'InteractiveLoginRequiredAuthError';

    Object.setPrototypeOf(this, InteractiveLoginRequiredAuthError.prototype);
  }
}
